import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";

interface IProps extends RouteComponentProps<{}>{
}

interface IState {
}

class ScrollToTop extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
    }

    public componentDidUpdate(prevProps: IProps) {
        if (this.props.location.pathname !== prevProps.location.pathname ||
        this.props.location.search !== prevProps.location.search
        ) {
            window.scrollTo(0, 0);
        }
    }

    public render() {
        return this.props.children;
    }
}

export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/presentation/scroll_to_top.tsx